const dateToFormat = (publishDate: string) => {
  let date = new Date(publishDate);
  const offset = date.getTimezoneOffset();
  date = new Date(date.getTime() - offset * 60 * 1000);
  return date.toISOString().split('T')[0];
};

export default dateToFormat;
